import { fromJS } from "immutable";

import TYPE from "../../constants/type";

// [VinUni] Module 6 - Hợp đồng TLNC (RA)
const initialState = fromJS({
  list: [],
  listByProfile: [],
  detail: null,
  availablePapers: [],
  warnings: [],
  isFetching: false,
  isSubmitting: false,
});

export default function raContractReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.RA_CONTRACT.GET_ALL_CONTRACT_LOADING:
    case TYPE.RA_CONTRACT.GET_CONTRACT_BY_PROFILE_LOADING:
    case TYPE.RA_CONTRACT.GET_CONTRACT_BY_ID_LOADING:
    case TYPE.RA_CONTRACT.GET_AVAILABLE_PAPERS_LOADING:
    case TYPE.RA_CONTRACT.GET_CONTRACT_WARNINGS_LOADING:
      return state.merge({ isFetching: true });

    case TYPE.RA_CONTRACT.GET_ALL_CONTRACT_FAILURE:
    case TYPE.RA_CONTRACT.GET_CONTRACT_BY_PROFILE_FAILURE:
    case TYPE.RA_CONTRACT.GET_CONTRACT_BY_ID_FAILURE:
    case TYPE.RA_CONTRACT.GET_AVAILABLE_PAPERS_FAILURE:
    case TYPE.RA_CONTRACT.GET_CONTRACT_WARNINGS_FAILURE:
      return state.merge({ isFetching: false });

    case TYPE.RA_CONTRACT.GET_ALL_CONTRACT_SUCCESS:
      return state.merge({ list: action.payload ?? [], isFetching: false });

    case TYPE.RA_CONTRACT.GET_CONTRACT_BY_PROFILE_SUCCESS:
      return state.merge({ listByProfile: action.payload ?? [], isFetching: false });

    case TYPE.RA_CONTRACT.GET_CONTRACT_BY_ID_SUCCESS:
      return state.merge({ detail: action.payload ?? null, isFetching: false });

    case TYPE.RA_CONTRACT.GET_AVAILABLE_PAPERS_SUCCESS:
      return state.merge({ availablePapers: action.payload ?? [], isFetching: false });

    case TYPE.RA_CONTRACT.GET_CONTRACT_WARNINGS_SUCCESS:
      return state.merge({ warnings: action.payload ?? [], isFetching: false });

    case TYPE.RA_CONTRACT.INSERT_CONTRACT_LOADING:
    case TYPE.RA_CONTRACT.UPDATE_CONTRACT_LOADING:
    case TYPE.RA_CONTRACT.DELETE_CONTRACT_LOADING:
    case TYPE.RA_CONTRACT.SET_ACTIVE_CONTRACT_LOADING:
    case TYPE.RA_CONTRACT.SET_COMPLETED_CONTRACT_LOADING:
    case TYPE.RA_CONTRACT.ADD_ACCEPTANCE_LOADING:
    case TYPE.RA_CONTRACT.DELETE_ACCEPTANCE_LOADING:
      return state.merge({ isSubmitting: true });

    case TYPE.RA_CONTRACT.INSERT_CONTRACT_FAILURE:
    case TYPE.RA_CONTRACT.UPDATE_CONTRACT_FAILURE:
    case TYPE.RA_CONTRACT.DELETE_CONTRACT_FAILURE:
    case TYPE.RA_CONTRACT.SET_ACTIVE_CONTRACT_FAILURE:
    case TYPE.RA_CONTRACT.SET_COMPLETED_CONTRACT_FAILURE:
    case TYPE.RA_CONTRACT.ADD_ACCEPTANCE_FAILURE:
    case TYPE.RA_CONTRACT.DELETE_ACCEPTANCE_FAILURE:
    case TYPE.RA_CONTRACT.INSERT_CONTRACT_SUCCESS:
    case TYPE.RA_CONTRACT.UPDATE_CONTRACT_SUCCESS:
    case TYPE.RA_CONTRACT.DELETE_CONTRACT_SUCCESS:
    case TYPE.RA_CONTRACT.SET_ACTIVE_CONTRACT_SUCCESS:
    case TYPE.RA_CONTRACT.SET_COMPLETED_CONTRACT_SUCCESS:
    case TYPE.RA_CONTRACT.ADD_ACCEPTANCE_SUCCESS:
    case TYPE.RA_CONTRACT.DELETE_ACCEPTANCE_SUCCESS:
      return state.merge({ isSubmitting: false });

    default:
      return state;
  }
}
